import {ParamComponent} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';
import {DATETIME_UNIT_OPTION_SECTION_ITEMS} from 'common/query-builder/query-block/properties-menu/constants';
import {
  ExtendedTimeUnit,
  NonStandardTimeUnit,
  SpecialTimeUnit,
  TimeUnit,
} from 'common/widgets/date-range-picker/models/types';

import {DateTab} from '../types';
import {template} from './template';
import css from './index.inline.styl';

type TimeGroup = Exclude<TimeUnit, ExtendedTimeUnit.Minute | NonStandardTimeUnit.Session> | SpecialTimeUnit | null;

interface DateBucketPaneParams {
  onUpdate: ({unit, isValid}: {unit: TimeGroup; isValid: boolean; focusSubmit: boolean}) => void;
  unit: TimeGroup;
}

interface DateBucketPaneStateJsxProps {
  params: DateBucketPaneParams;
}

interface DateBucketPaneState {
  lastUnit: TimeGroup;
}

export class DateBucketPane extends ParamComponent<DateBucketPaneParams, DateBucketPaneState> {
  get config() {
    return {
      css,
      template,
      useShadowDom: true,
      params: {
        onUpdate: Function,
        unit: String,
      },
      defaultParams: {
        onUpdate: () => null,
        unit: null,
      },
      defaultState: {
        lastUnit: TimeUnit.Day,
      },
    };
  }

  getItemsMenuSections() {
    return [
      {
        items: DATETIME_UNIT_OPTION_SECTION_ITEMS.map((item) => ({
          ...item,
          isSelected: item.value === this.params.unit,
        })),
      },
    ];
  }
  handleClickUnit(ev) {
    this.dispatchUnitUpdate(ev.detail.value);
  }
  dispatchUnitUpdate(unit: TimeGroup) {
    this.params.onUpdate({
      unit,
      isValid: true,
      focusSubmit: true,
    });
  }
  getPreviewForUnit(unit: TimeGroup) {
    switch (unit) {
      case TimeUnit.Second:
        return `not supported`;
      case TimeUnit.Hour:
        return `Ex. Tue Oct 18, 2022 6:00 AM, ...`;
      case TimeUnit.Day:
        return `Ex. Jul 18, 2022, Jul 19, 2022,  ...`;
      case TimeUnit.Week:
        return `Ex. Jul 18, 2022 - Jul 24, 2022, ...`;
      case TimeUnit.Month:
        return `Ex. Jul 2022, Aug 2022, ...`;
      case TimeUnit.Quarter:
        return `Ex. Q1 2022, Q2 2022, ...`;
      case TimeUnit.Year:
        return `Ex. 2022, 2023, ...`;
      case SpecialTimeUnit.HourOfDay:
        return `Ex. 06:00, 07:00, ...`;
      case SpecialTimeUnit.DayOfWeek:
        return `Ex. Monday, Tuesday, ...`;
      case null:
        return `Ex. 2022-07-18T14:05:40, ...`;
    }
  }
  handleTabClick(ev) {
    if (ev.detail.selected === DateTab.Iso) {
      this.update({lastUnit: this.params.unit});
      this.dispatchUnitUpdate(null);
    } else {
      this.dispatchUnitUpdate(this.state.lastUnit);
    }
  }
}

export const DateBucketPaneEl = defineAndMakeJsxFactory<DateBucketPaneStateJsxProps>(
  `mp-date-bucket-pane`,
  DateBucketPane,
);
export const DateBucketPaneReact = panel2react<DateBucketPaneStateJsxProps>(`mp-date-bucket-pane`, DateBucketPane);
